import useSWR from "swr";
import { useDateFilters } from "../../../hooks/useDateFilters";
import { useUser } from "../../../../../utils/hooks/user";
import { usePreferences } from "../../../../Settings/Configuration/hooks/usePreferences";
import { formatDateRange } from "../../../../../utils/helpers/api";

export const useRetroAdjustments = (user) => {
    const loggedUser = useUser();
    const hideRetroAdjustment = usePreferences("timeSheetGeneral.hideRetroAdjustment");
    const { from, to } = useDateFilters();
    const { data, mutate } = useSWR(() => {
        if (!user?.id || !loggedUser?.permissions?.timeSheet?.canViewRetro || hideRetroAdjustment) {
            return null;
        }
        return {
            url: `/retro-adjustment/user/${user.id}`,
            params: {
                ...formatDateRange(from, to),
                pagination: "false",
                status: ["pending", "approved"]
            },
        };
    });
    return { data, mutate };
}
